import * as Colors from "../../globalStyles/environmentColors";

export const body = {
	backgroundColor: Colors.background,
};
